import { createStore } from "vuex";
import APPLICATION from "./modules/application.js";
import BROWSER from "./modules/browser.js";
import CART from "./modules/cart.js";

const store = createStore({
  state: {
    // browser properties
    FILTER: {
      color: "",
      rol: "",
      rug: "",
      methode: "",
    },
    VUE: {
      update: false,
    },
  },
  mutations: {
    // set Filter options selection
    storeFILTER: function (state, mutation) {
      state.FILTER[mutation.key] = mutation.value;
    },
    storeVueUpdate: function (state, mutation) {
      state.VUE.update = mutation;
    },
  },
  actions: {},
  modules: {
    APPLICATION,
    BROWSER,
    CART,
  },
  getters: {
    // get Filter options selection
    getFILTER: (state) => {
      return state.FILTER;
    },
    getVueUpdate: function (state) {
      return state.VUE.update;
    },
  },
});

export default store;
